import styled from 'styled-components';
import { baseVariables } from '../../styles';
import { MVideoBackgroundButtonPosition } from './MVideoBackground.types';
import { AVideoAspectRatio } from '../../atoms/AVideo/AVideo.types';
import { getAspectRatioValue } from '../../atoms/AVideo/AVideo.styles';

const { mediaQuery } = baseVariables;

export const Wrapper = styled.div<{ $aspectRatio?: AVideoAspectRatio; $fillContainer?: boolean }>`
  position: relative;
  width: 100%;
  ${({ $fillContainer, $aspectRatio }) =>
    $fillContainer ? `height: 100%;` : `aspect-ratio: ${$aspectRatio ? getAspectRatioValue($aspectRatio) : '16 / 9'};`}
  overflow: hidden;
  border-radius: 0;
  cursor: pointer;

  @media ${mediaQuery.md} {
    border-radius: ${({ $fillContainer }) => ($fillContainer ? '0' : 'var(--t-images-border-radius, 14px)')};
  }
`;

export const VideoContainer = styled.div`
  position: absolute;
  inset: 0;

  > * {
    width: 100%;
    height: 100%;
  }

  .video-js {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    padding-top: 0;
  }

  .vjs-poster {
    background-size: cover;
    background-position: center;

    img {
      object-fit: cover;
    }
  }

  video {
    object-fit: cover;
  }
`;

export const OverlayContainer = styled.div<{ $buttonPosition: MVideoBackgroundButtonPosition }>`
  position: absolute;
  inset-inline-end: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${baseVariables.spacers?.spacers?.[4] ?? '1.5rem'};
  z-index: 1;

  ${({ $buttonPosition }) => ($buttonPosition === MVideoBackgroundButtonPosition.Top ? `top: 0;` : `bottom: 0;`)}
`;

export const ErrorOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--t-error-overlay-bg, #000000);
  color: var(--t-error-overlay-text, #ffffff);
  z-index: 2;
`;

export const ErrorText = styled.p`
  color: inherit;
  font: normal normal 400 var(--t-font-s-font-size-viewport-xs, 0.875rem) /
    var(--t-font-s-line-height-viewport-xs, 1.25rem) var(--t-base-font-family);
  text-align: center;
  margin: 0;
  padding: ${baseVariables.spacers?.spacers?.[3] ?? '1rem'};
  word-break: break-word;
`;
